import React from "react";
import { ContactAsSection } from "../components/ContactAsSection/ContactAsSection";
import Section from "../components/Section/Section";
import { useTranslation } from "react-i18next";
import { HeroImage } from "../components/Image/Image.styled";
import GenaralImg from "../assets/pages/home/hero/general.jpg";

const i18nKey = "pages.about";

const AboutPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <HeroImage
        src={GenaralImg}
        alt={t(`${i18nKey}.title`)}
        $position={"center 56%"}
      />
      <Section
        withBackgroundImg={false}
        header={i18nKey ? t(`${i18nKey}.title`) : ""}
        textKey={`${i18nKey}.text`}
      ></Section>
      <ContactAsSection />
    </>
  );
};

export default AboutPage;
